import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import {ROUTER_LOGIN_URL} from 'config/urls';
import history from 'config/history';

import {userProfileRequest} from 'ducks/auth';

import {getAuthToken} from 'utils/localStorage';

export interface LoginRequiredProps {
  user: any;
}

const LoginRequired = <T extends any>(
  WrappedComponent: React.ComponentType<T & LoginRequiredProps>
) => {
  class Wrapper extends React.Component<
    T & ReturnType<typeof mapStateToProps>
  > {
    componentDidMount() {
      const {me, dispatch} = this.props;
      const token = getAuthToken();

      if (token && !me) {
        dispatch(userProfileRequest());
      }

      if (!token) {
        // We want to redirect back the user to the page from which he was redirected to login.
        // What we do is to store original page url in a GET parameter called `_next=`.
        // There might be other GET parameters (e.g. opened modal). We concatenate them with the `_next=` one.
        // *NOTE* This requires to replace the `?` (the start of the GET params) from the original GET params with `&` (concatenation)
        const loginUrl = `${ROUTER_LOGIN_URL}?_next=${
          history.location.pathname
        }${_.replace(history.location.search, '?', '&')}`;

        dispatch(push(loginUrl));
      }
    }

    render() {
      const restOfProps: T = this.props;
      const me = this.props.me;

      if (!me) {
        return null;
      }

      return <WrappedComponent user={me} {...restOfProps} />;
    }
  }

  const mapStateToProps = state => {
    return {
      me: state.auth.me
    };
  };

  return connect(mapStateToProps)(Wrapper as React.ComponentType<T>);
};

export default LoginRequired;
